import React, { FC, useContext, useEffect, useState } from 'react';

import Paper from '@material-ui/core/Paper';
import moment from 'moment';
import Slider from 'react-slick';

import { IClub } from '../../../../store/player/clubs/store';

import { sortBy } from '../../../../contrib/sortBy';
import ClubPickerItem from './Utils/ClubPickerItem';
import { GlobalContext } from '../../../../store';
import { clubPickerSettings } from './Utils/clubPickerSettings';
import { today } from '../../../../Utils/today';
import { IGame } from '../../../../store/player/games/store';

const ClubPicker: FC = () => {
  const { clubs, games } = useContext(GlobalContext);

  const [allClubs, setAllClubs] = useState<IClub[]>([]);
  const [sortedClubs, setSortedClubs] = useState<IClub[]>([]);
  const [collapsed, setCollapsed] = useState(false);

  useEffect(() => {
    if (!!clubs.all) {
      const newAllClubs = Object.values(clubs.all);

      setAllClubs(newAllClubs);
      setSortedClubs(sortBy(newAllClubs, 'asc', 'status'));
    }
  }, [clubs]);

  useEffect(() => {
    const allGames: IGame[] = sortBy(Object.values(games), 'asc', 'start');

    const foundCurrentGame = allGames.find(e => false && moment(e.group.start).isAfter(today));

    setCollapsed(!foundCurrentGame);
  }, [games, today]);

  return (
    <div className={`club-picker ${collapsed ? 'collapsed' : ''}`}>
      <Paper elevation={1} className="paper">
        <h4>My Club Memberships</h4>

        {allClubs.length === 0 ? (
          <div className="empty-clubs override">
            It looks like you haven't been added to any clubs yet
          </div>
        ) : allClubs.length > 3 ? (
          <Slider {...clubPickerSettings}>
            {sortedClubs.map(club => (
              <ClubPickerItem key={`club${club.id}`} club={club} />
            ))}
          </Slider>
        ) : (
          <div className="fixed">
            {sortedClubs.map(club => (
              <ClubPickerItem key={`club${club.id}`} club={club} />
            ))}
          </div>
        )}
      </Paper>
    </div>
  );
};

export default ClubPicker;
